import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Smooth-scroll the window to top whenever the route changes. */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);
  return null;
}

export default ScrollToTop;
